import { Cliente } from "./cliente.model";
import { Faturamento } from "./faturamento.model";
import { DescricaoPadrao } from "./../models/descricaoPadrao.model";
import { AliquotaSimplesNacional } from "./../models/aliquotaSimplesNacional.model";
import { ContaContabil } from "./contaContabil.model";

export class Usuario {
    id: string = '';
    createdAt: Date = new Date();
    nomeEmpresa: string = '';
    cpfCnpj: string = '';
    telefone: string = '';
    email: string = '';
    oab: string | null = null;
    inscricaoMunicipal: string | null = null;
    contasContabeis: ContaContabil[] = [];
    clientes: Cliente[] = [];
    descricoesPadroes: DescricaoPadrao[] = [];
    aliquotasSimplesNacional: AliquotaSimplesNacional[] = [];
    faturamentos: Faturamento[] = [];
}
